import {Util} from 'yougile-util'
import {FileUploadProgress} from '@components/file-upload-progress'
import {ClientUtilities} from '@client/client-utilities'

export const uploadFile = (file: File): Promise<string> => {
  return new Promise((res, rej) => {
    const id = Util.UUID()
    FileUploadProgress.addFile(id, file)
    ClientUtilities.saveFile(
      {file},
      url => {
        FileUploadProgress.removeFile(id)
        if (!url) {
          rej()
          return
        }

        res(url)
      },
      percents => FileUploadProgress.updateProgress(id, percents)
    )
  })
}
